/*
 * Purpose : To display the input conent in tabular format
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React, { Component } from 'react'
import { Alert } from 'reactstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import { errorConstants } from './../../../config/constants';
import { headerMapping, sectionalHeaderMapping } from './../../../config/view-form-mappings';


export default class ViewTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [],
            error: false,
            errorMsg: ""
        }
        this.frameContent = this.frameContent.bind(this)
        this._arrayBufferToBase64 = this._arrayBufferToBase64.bind(this)
    }
    componentDidMount() {
        try {
            if (!this.props.header || !this.props.data) {
                throw new Error("Data for the component not defined")
            }
            const items = []
            items.push(<div className="viewHeader" key={this.props.header}>
                <h4>{headerMapping[this.props.header]} </h4>
            </div>)
            //console.log("this.props.data==>",this.props.data)
            this.frameContent(this.props.data, items)
            this.setState({
                items
            })
        }
        catch (err) {
            this.setState({
                error: true,
                errorMsg: errorConstants.errorloading
            })
        }
    }

    /**  CHG0099515 - Rendering Problem fix 
     * making the tables Normalize code 
     -Normalize "Missingparts" sections data 
     -Normalize "FaultyItems" sections data
     -Normalize "Hardwaresub fab" section data 
    * ensure item is an array, otherwise default to empty array
    */
    frameContent = (item, items) => {
        try {
            const normalizedMissingParts = Array.isArray(item)
                ? item.filter(r =>
                    (r.description && r.description.trim() !== "" && r.description !== "<empty>") ||
                    (r.quantity && r.quantity.trim() !== "" && r.quantity !== "<empty>")
                )
                : [];
            const normalizedMFaultyParts = Array.isArray(item)
                ? item.filter(row =>
                    // Excluding rows where both description and quantity are empty
                    !(
                        (row.description ?? "").trim() === "" &&
                        (row.quantity ?? "").trim() === ""
                    )
                )
                : [];

            const normalizedHardwareSubFab = Array.isArray(item)
            ? item.filter(row => {
                // Default empty values to empty string
                const desc = row.description ?? "";
                const qty = row.quantity ?? "";
           
                return (
                    //keep row if description is meaningful
                  desc.trim() !== "" &&
                  desc !== "<empty>"
                ) || (
                  qty.trim() !== "" &&
                  qty !== "<empty>"
                );
              })
            : [];
          
            if (item && item instanceof Array) {
                item.map(el => {
                    delete el.transactionid
                    return el
                })
                if (this.props.header === "general" || this.props.header === "transaction") {
                    // Item count check made on parent. We can safely use [0]
                    const rows = []
                    const section = item[0]

                    Object.keys(section).forEach((row, i) => {
                        let value = ""
                        if (row.toLowerCase() === "transactiontype") {
                            return;
                        }
                        else if (row.toLowerCase() === "approved") {
                            if (section[row].toLowerCase().trim() === "approved") {
                                value = <b style={{ "color": "green" }}>{section[row].toUpperCase()}</b>
                            }
                            else if (section[row].toLowerCase().trim() === "rejected") {
                                value = <b style={{ "color": "red" }}>{section[row].toUpperCase()}</b>
                            }
                            else {
                                value = <b style={{ "color": "orange" }}>{section[row]}</b>
                            }
                        }
                        else {
                            value = section[row]
                        }
                        rows.push(
                            <tr key={i} className={"view-main-row"}>
                                <td className={"view-row"}> <b>{sectionalHeaderMapping[row]}</b> </td>
                                <td className={"view-row"}> {value} </td>
                            </tr>
                        )
                    })

                    items.push(
                        <div key="0">
                            <table className={"view-table"}>
                                <tbody>
                                    {rows}
                                </tbody>
                            </table>
                        </div>
                    )
                }
                else if (this.props.header === "photos") {
                    if (item.length > 0) {
                        const rows = []
                        item.forEach(el => {
                            if (el.systemtype !== "configfiles") {
                                if (el.toolpicture) {
                                    const buff = this._arrayBufferToBase64(el.toolpicture.data)
                                    rows.push(
                                        <tr>
                                            <td className={"view-row"}>{headerMapping[el.systemtype]}</td>
                                            <td className={"view-row"}>{el.description}</td>
                                            {
                                                buff
                                                    ? <td className={"view-row"}><img src={"data:" + el.mimetype + ";base64," + buff} alt="problem in loading tool" style={{ minWidth: "700px", maxWidth: "700px", maxHeight: "700px" }} /></td>
                                                    : <td className={"view-row"}><img src={"data:" + el.mimetype + ";base64," + buff} alt="problem in loading tool" style={{ maxWidth: "100px", maxHeight: "100px" }} /></td>
                                            }
                                        </tr>

                                    )
                                }
                                else {
                                    rows.push(
                                        <tr>
                                            <td className={"view-row"}>{headerMapping[el.systemtype]}</td>
                                            <td className={"view-row"}>{el.description}</td>
                                            <td></td>
                                        </tr>
                                    )
                                }
                            }
                        })
                        items.push(
                            <div key="photoDiv">
                                <table className={"view-table"}>
                                    <tbody>
                                        {rows}
                                    </tbody>
                                </table>
                            </div>)
                    }
                    else {
                        items.push(<div key="photoDiv">No records</div>)
                    }
                }
                else if (this.props.header === "configfiles") {
                    if (item.length > 0) {
                        const rows = []
                        item.forEach(el => {
                            if (el.toolpicture) {
                                const byteArray = new Uint8Array(el.toolpicture.data)
                                const blob = new Blob([byteArray], { type: el.mimetype })
                                const url = window.URL.createObjectURL(blob)
                                let fileName = el.toolfilename.indexOf("-$") !== -1 ? el.toolfilename.replace(el.toolfilename.substr(el.toolfilename.indexOf("-$"), 10), "") : el.toolfilename
                                //const urlNew="https://excess-equip-file-storage34817-eqppoc.s3.amazonaws.com/public/dummy03-%24kg1t1qr4.pdf?AWSAccessKeyId=ASIASVPRIJNLNUBK7J65&Expires=1602243820&Signature=lPlulscDBENmdp3tG8GiPjtYySc%3D&x-amz-security-token=IQoJb3JpZ2luX2VjEAwaCXVzLWVhc3QtMSJHMEUCIBdBvBMJhDooWuDL%2BrF2229YpnHOjkIz6XBWowZ3OJwUAiEAsiwBH8TJE4LTNs1617j8XqXiibPsAwcxQjNYd6WNzd8qygEIRBAAGgwxODM1Nzg5MzgxOTgiDJTgeioF9joeq2qD%2BiqnAay9UExCueqJKdKuDpFfZSJkw94cfEEcLF7J%2BycHuvGbxWA94ZuT3CKJTy0QVYLqlq0JUvGJW8p5tBWhY21oq5kXsO7j%2B%2FrcewFvsx%2BKLRw3dq%2BHTNuoKjjEnr8443n6m77%2Bk5Yf0tNFYmwW%2BeXLfZ6j8NPESWkNUqwwlVyV3J16hMOnxtP1PYP04xbtfTj3zhgypoU0%2Bv%2FU6L126AlgOVXJoVAPuOmCMJ6OgfwFOuABXWF51%2FwuPRbNWZh%2BS65aonDdbulictQVgV4mutw4jBHlv6e4BfQQbVFSqUR3Erft%2BK2NezXyQ8EA%2BaERS8Zlp59B8cgzJeT1F6SqtTX5QjFkC0HvmRQ3y%2BjmmuCh20Ehg0p2A6JpoRgi6NGDmTYCCUys%2Fbk1hjSGj%2FkXSywNhHst0jSkWE0rKg7whP8dY0Oyap%2B7VHX59vWvauMgZ12ruP%2FOSUeeMnmnpV8v3kNxA%2Fn7TmqDr7FyOYuGjjrNA1pOY8RY2AlX7%2FMMfpQ2rC3MVTFDZAwwelqAPHiPn2%2FFHHs%3D"
                                rows.push(
                                    <tr>
                                        <td className={"view-row"}>{el.description}</td>
                                        <td className={"view-row"}><a target="_blank" href={url} download={fileName} > {fileName} </a></td>
                                    </tr>
                                )
                            }
                            else {
                                rows.push(
                                    <tr>
                                        <td className={"view-row"}>{headerMapping[el.systemtype]}</td>
                                        <td className={"view-row"}>{el.description}</td>
                                        <td></td>
                                    </tr>
                                )
                            }
                        })
                        items.push(
                            <div key="confDiv">
                                <table className={"view-table"}>
                                    <tbody>
                                        {rows}
                                    </tbody>
                                </table>
                            </div>)
                    }
                    else {
                        items.push(<div key="confDiv">No records</div>)
                    }
                }
                else {
                    /** CHG0099515
                     * Decide which normalize data to use based on section header 
                     * Identify sections that normalized log
                     */

                    const tableData =
                        this.props.header === "missingparts"
                            ? normalizedMissingParts
                            : this.props.header === "faultyparts"
                                ? normalizedMFaultyParts
                                : this.props.header === "hardwaresubfab"
                                    ? normalizedHardwareSubFab
                                    : item;
                                
                    //Debug Logs - CHG0099515

                    console.log ("Section :", this.props.header)
                    console.log ("RAW Data :", item)
                    console.log ("Filtered Data :", tableData)


                    const isNormalizedSection = 
                    this.props.header === "hardwaresubfab" || 
                    this.props.header === "missingparts" ||
                    this.props.header === "faultyparts" ;

                    // determine if the section has no data
                    const isNoData = isNormalizedSection
                        ? tableData.length === 0
                        : item.length === 0 ;

                    // Render table only if data is present 
                    if (!isNoData) {
                        const columns = [];

                        //Dynamically build table headers
                        Object.keys(tableData[0]).forEach((col, i) => {
                            columns.push(
                                <TableHeaderColumn key={i} isKey={i === 0} dataField={col}>
                                    {sectionalHeaderMapping[col]}
                                </TableHeaderColumn>
                            );
                        });

                        items.push(
                            <div className="view-table">
                                <BootstrapTable data={tableData}>
                                    {columns}
                                </BootstrapTable>
                            </div>
                        );
                    } else {
                        items.push(<div>No records</div>);
                    }

                }
            }
            else {
                this.setState({
                    error: true,
                    errorMsg: errorConstants.errorloading
                })
                return
            }
        }
        catch (err) {
            this.setState({
                error: true,
                errorMsg: errorConstants.errorloading
            })
        }
    }
    _arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }
    render() {

        return (
            <div className={"view-main"}>
                {this.state.items}
                <Alert color="danger" isOpen={this.state.error}>{this.state.errorMsg}</Alert>
            </div>
        )
    }
}
